export const defaultErrorMessage = 'Something went wrong. Please try again.';
